/* eslint-disable react/prop-types */
import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useMergeState } from 'irmlib/hooks'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
import * as localGdeTransactionLite from '../../../services/firestore/localGdeTransactionsLite'
import { setBusy, clearBusy, openGeneralDialog, closeGeneralDialog } from 'irmlib/containers'
// import { TextField, Select, CancelButton, SaveButton, Autocomplete } from '../../../irmlib/src/components/FormControls'
import { Label, ThemeButton } from 'irmlib/components/Controls'
import { YDivider } from 'irmlib/styles'
import { errorToast, successToast } from '../../../common/functions'
import { Button, Typography, CircularProgress } from '@material-ui/core'
import { Grid, Box, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton } from '@mui/material'
import styled from 'styled-components'
import RequestTemplateFormat from '../Template/RequestListTemplate.jsx'
// import { getDownloadURL, ref as storageRef, uploadBytes } from 'firebase/storage'
// import { storage } from '../../../utils/firestore'
import * as constants from '../../../irmlib/src/common/constants'
import { InputFileUploadButton } from './UploadButton.jsx'
// import { ContactSupportOutlined } from '@material-ui/icons'
// import { pagePadding } from '../../AppControl/constants.js'
import CloseIcon from '@mui/icons-material/Close'
import { TransformWrapper, TransformComponent, useControls } from 'react-zoom-pan-pinch'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import ZoomOutIcon from '@mui/icons-material/ZoomOut'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import { getUser } from '../../../redux/global.js'
// import { uploadRefImg, getImgFromNats, getNatsURL, publishImgData } from '../../../services/nats/localNatsTransactions'
import { useNats } from '../../../providers/NatsProvider.jsx'
import { useGetNatsImage } from '../../../services/nats/useGetNatsImage'
import { deleteNatsCapturedImagesForBox } from '../../../services/nats/natsObjectStoreUtils'

const BottomPaddedButton = props =>
  <>
    <ThemeButton {...props} />
    <VerticalDivider />
  </>

const VerticalDivider = () =>
  <YDivider height='20px' />

// const ErrorLabel = styled.label`
//     display: flex
//     width: 100%
//     justify-content: flex-end
//     color: red
//     margin-top: 5px
//     font-size: 11px
// `
const ZoomTool = styled.div`
  position: absolute ;
  z-index: 1 ;
  background-color: rgb(255, 255, 255, 0.8);
  border-radius: 5px;
  box-shadow: 1px 1px 2px black;
  /* border: 1px solid red; */
`

const initialSate = {
  selectedImage: false,
  selectedImageGsPath: false,
  error: '',
  templateData: [],
  newTemplateId: '',
  confidence: 0
}
export const updateTemplateFields = (template, confidence) => {
  Object.keys(template).map((key) => {
    template[key].confidence = confidence ? Number(confidence) : 0
    return true
  })
  return template
}

export const UpdateRefImage = (props) => {
  const { rowData, onClose } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const { workerId } = getUser()
  const { natsService } = useNats()
  const { getImgFromNats } = useGetNatsImage()
  // const tableRef = useRef()
  const [isDialogOpen, setDialogOpen] = useState(false)
  const [newUpldImg, setNewUpldImg] = useState(null)
  const [isSaving, setIsSaving] = useState(false) // Add loading state

  useEffect(() => {
    setDialogOpen(true) // Open dialog on component mount
  }, [])

  const setError = (value) => {
    setState({ error: value })
  }

  const ContentForDialogBox = () => {
    return (<>
      <Box sx={{ flexGrow: 1, minHeight: 300 }}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
              <TransformWrapper>
                {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                  <>
                    <Controls />
                    <TransformComponent>
                      <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                        {rowData.currentImageURL !== ''
                          ? <img src={rowData.currentImageURL} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />
                          : <Label style={{ width: '100%', height: 250 }}></Label>
                        }
                      </div>
                    </TransformComponent>
                  </>
                )}
              </TransformWrapper>
            </Box>
            <Typography variant="body1">{`${t('smartCatalog.currentRefImg')}`}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
              <TransformWrapper>
                {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                  <>
                    <Controls />
                    <TransformComponent>
                      <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                        {newUpldImg &&
                          <img src={newUpldImg} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />}
                      </div>
                    </TransformComponent>
                  </>
                )}
              </TransformWrapper>
            </Box>
            <Typography variant="body1" component="div">
              {/* <InputFileUploadButton onImageCapture={handleImageUpload} error={getState().error} setError={setError} maxSize={5} allowedFormats={['JPG', 'JPEG']} /> */}
              <InputFileUploadButton onImageCapture={handleImageUploadToNats} error={getState().error} setError={setError} maxSize={5} allowedFormats={['JPG', 'JPEG']} />
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>)
  }

  const ButtonsForSaveAndAssignJob = (props) => (
    <>
      <BottomPaddedButton
        color="primary"
        variant="outlined"
        onClick={onCancel}
        disabled={isSaving} // Disable cancel button while saving
      >
        {t('buttons.cancel')}
      </BottomPaddedButton>
      <Button
        variant="contained"
        color="primary"
        disabled={!newUpldImg?.length || isSaving} // Disable while saving or no image
        onClick={postService}
      >
        {isSaving
          ? <>
            <CircularProgress size={16} style={{ marginRight: 8, color: 'white' }} />
            {t('buttons.updating') || 'Updating...'}
          </>
          : t('buttons.update')
        }
      </Button>
    </>
  )

  const onCancel = () => {
    if (!isSaving) { // Prevent closing while saving
      setDialogOpen(false) // Close the dialog
      onClose()
    }
  }

  // const handleImageUpload = async (value) => {
  //   if (value) {
  //     setBusy()
  //     const imageRef = storageRef(storage, `smartCatalog/gde_refImg_${workerId}_${Date.now()}.jpg`)
  //     uploadBytes(imageRef, value)
  //       .then((snapshot) => {
  //         getDownloadURL(snapshot.ref)
  //           .then((url) => {
  //             const gspath = `gs://${snapshot.ref.bucket}/${snapshot.ref.fullPath}`
  //             setState({
  //               selectedImage: url,
  //               selectedImageGsPath: gspath,
  //             })
  //             setError('')
  //             clearBusy()
  //           })
  //           .catch((error) => {
  //             // eslint-disable-next-line
  //             console.log(error.message)
  //             setError(t('error.imageUploadFail'))
  //             clearBusy()
  //           })
  //       })
  //       .catch((error) => {
  //         // eslint-disable-next-line
  //         console.log(error.message)
  //         setError(t('error.imageUploadFail'))
  //         clearBusy()
  //       })
  //   }
  // }

  const handleImageUploadToNats = async (originalFile) => {
    if (originalFile) {
      const rename = `nats_refImg_${workerId}_${Date.now()}.jpg`
      const renamedFile = new File([originalFile], rename, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      })
      // const { nuid, name } = await uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, renamedFile)
      const { nuid, name } = await natsService.uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, renamedFile)
      setState({
        selectedImage: name,
        selectedImageGsPath: nuid,
      })
      // const tmpUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      // const tmpUrl = await natsService.getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      const tmpUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      setNewUpldImg(tmpUrl)
    } else {
      const error = getState().validationErrors
      setState({ validationErrors: { ...error, btnError: 'Incorrect format or size.' } })
    }
  }

  const postService = async postObject => {
    if (!getState().selectedImage) {
      setError('Please upload an image.')
      return
    }

    setIsSaving(true) // Set loading state
    setBusy() // Show global busy indicator

    try {
      const parentActivityId = rowData.activityId
      const activityDetails = await localGdeTransactions.getActivityByID(parentActivityId)
      const initialStatus = activityDetails.status
      let newStat
      if (initialStatus === constants.activityStatus.pending || initialStatus === constants.activityStatus.inProgress) {
        newStat = initialStatus
      } else {
        newStat = false
      }

      const activityData = {
        imgReference: getState().selectedImage,
        imgReferenceURI: getState().selectedImageGsPath,
        status: 'In Progress',
        isPublished: false,
        isProcessed: false,
        updatedTS: (new Date()).toISOString(),
      }
      await localGdeTransactions.updateActivityData(parentActivityId, activityData)
      const imageData = {
        idp: {
          statusCode: '',
          status: '',
          exception: ''
        },
        idpResponse: {},
        isPublished: false,
        isProcessed: false,
        processedAt: '',
        publishedAt: '',
        messageId: '',
        idp_message_id: '',
        status: constants.activityStatus.submitted,
        updatedTS: (new Date()).toISOString(),
        imgReference: getState().selectedImage,
        imgReferenceURI: getState().selectedImageGsPath,
      }
      // await localGdeTransactions.getImagesAndUpdate(parentActivityId, imageData, newStat)
      await localGdeTransactions.getImagesAndUpdate(parentActivityId, imageData, newStat, natsService.publishImgData.bind(natsService))
      successToast({ message: t('toast.refImageUpdate'), title: t('toast.success') })

      // Close dialog after successful update
      setDialogOpen(false)
      onClose()
    } catch (error) {
      console.error('Error updating reference image:', error)
      errorToast({ message: t('toast.failedToUpdate') || 'Failed to update reference image', isBlocking: false })
      setIsSaving(false) // Reset loading state on error
      clearBusy() // Clear busy indicator on error
    } finally {
      // Note: clearBusy is called in finally, but setIsSaving is only reset on error
      // because on success we close the dialog
      if (!isSaving) {
        clearBusy()
      }
    }
  }

  return (
    <Dialog
      open={isDialogOpen}
      onClose={onCancel}
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '80vh',
          width: 'auto',
          maxWidth: '80%',
          overflow: 'hidden',
        },
        '& .MuiDialogContent-root': {
          padding: '16px',
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle>
        {t('templates.refImageUpdate', { boxId: rowData.boxId })}
        <IconButton
          edge="end"
          color="inherit"
          onClick={onCancel}
          aria-label="close"
          disabled={isSaving} // Disable close button while saving
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#58595B',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: '0px' }}>
        <ContentForDialogBox />
      </DialogContent>
      <DialogActions>
        <ButtonsForSaveAndAssignJob />
      </DialogActions>
    </Dialog>
  )
}

UpdateRefImage.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}

export const UpdateTemplate = (props) => {
  const { rowData, onClose } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const tableRef = useRef()
  const { natsService } = useNats()
  const { getImgFromNats } = useGetNatsImage()

  const [selectedImage, setSelectedImage] = useState(null)
  const [loadingImage, setLoadingImage] = useState(false)
  const [imageError, setImageError] = useState(false)
  const imageCache = useRef(new Map())
  const isDialogOpenRef = useRef(false)

  useEffect(() => {
    openGeneralDialog({
      title: t('smartCatalog.templates'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <div><ContentForDialogBox /></div>,
      buttons: <ButtonsForSaveAndAssignJob update={onTemplateSelection} />,
      closeX: false
    })
  }, [])

  const loadImageFromNats = async (imgReference) => {
    if (!imgReference) return null

    return await getImgFromNats(
      constants.LOCAL_NATS_SERVER,
      constants.LOCAL_AI_REF_IMG,
      imgReference,
      true // Enable caching
    )

    // --- OLD CODE ---
    // // Check cache first
    // if (imageCache.current.has(imgReference)) {
    //   return imageCache.current.get(imgReference)
    // }
    // 
    // // For non-NATS images (URLs), return immediately and cache
    // if (!imgReference.includes('nats')) {
    //   if (imgReference.startsWith('http://') ||
    //     imgReference.startsWith('https://') ||
    //     imgReference.startsWith('data:')) {
    //     imageCache.current.set(imgReference, imgReference)
    //     return imgReference
    //   }
    //   return null
    // }
    // 
    //     // Check if it's a NATS image
    // if (imgReference.includes('nats')) {
    //   try {
    //     // const imageUrl = await natsService.getImgFromNats(
    //     //   constants.LOCAL_NATS_SERVER,
    //     //   constants.LOCAL_AI_REF_IMG,
    //     //   imgReference
    //     // )
    //     const imageUrl = await getImgFromNats(
    //       constants.LOCAL_NATS_SERVER,
    //       constants.LOCAL_AI_REF_IMG,
    //       imgReference
    //     )
    //     if (imageUrl) {
    //       imageCache.current.set(imgReference, imageUrl)
    //       return imageUrl
    //     }
    //   } catch (error) {
    //     console.error('Error loading image from NATS:', error)
    //     return null
    //   }
    // }
    // 
    // return null
  }

  const handleImageClick = async (imgReference) => {
    if (!imgReference) {
      // If no reference, show error immediately
      setImageError(true)
      setLoadingImage(false)
      setSelectedImage(null)
      return
    }

    // Reset error state
    setImageError(false)

    // --- OLD CODE ---
    // // Check cache first
    // if (imageCache.current.has(imgReference)) {
    //   const cachedImage = imageCache.current.get(imgReference)
    //   if (cachedImage) {
    //     isDialogOpenRef.current = true
    //     setSelectedImage(cachedImage)
    //     setLoadingImage(false)
    //     setImageError(false)
    //     return
    //   }
    // }
    
    isDialogOpenRef.current = true
    // Open dialog immediately with loading state
    setLoadingImage(true)
    setSelectedImage(null)
    setImageError(false)

    try {
      const imageUrl = await loadImageFromNats(imgReference)
      if (isDialogOpenRef.current) {
        if (imageUrl) {
          setSelectedImage(imageUrl)
          setImageError(false)
        } else {
          setSelectedImage(null)
          setImageError(true) // Set error if image couldn't be loaded
        }
      }
    } catch (error) {
      console.error('Error loading image:', error)
      if (isDialogOpenRef.current) {
        setSelectedImage(null)
        setImageError(true) // Set error on exception
      }
    } finally {
      if (isDialogOpenRef.current) {
        setLoadingImage(false)
      }
    }
  }

  const handleCloseImageDialog = () => {
    isDialogOpenRef.current = false
    setSelectedImage(null)
    setLoadingImage(false)
    setImageError(false) // Reset error state when closing
  }

  const ImageContainer = () => {
    // Keep dialog open if loading, has image, or has error
    const isOpen = loadingImage || !!selectedImage || imageError

    if (!isOpen) return null

    return (
      <Dialog
        open={isOpen}
        onClose={handleCloseImageDialog}
        maxWidth="sm"
      >
        <DialogContent>
          {loadingImage && !selectedImage && !imageError
            ? <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '400px',
              minWidth: '400px',
              gap: 2
            }}>
              <CircularProgress size={40} />
              <Typography variant="body2" color="textSecondary">
                {t('Search.loading')}
              </Typography>
            </Box>
            : selectedImage && !imageError
              ? <img
                src={selectedImage}
                alt="Reference Image"
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  display: 'block',
                  margin: '0 auto'
                }}
                onError={() => {
                  // Image failed to load even though we got a URL
                  setSelectedImage(null)
                  setLoadingImage(false)
                  setImageError(true) // Show error message instead of closing
                }}
              />
              : <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px',
                minWidth: '400px',
                gap: 2
              }}>
                <Typography variant="body2" color="textSecondary">
                  {t('smartCatalog.imageNotAvailable')}
                </Typography>
              </Box>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImageDialog} color="primary">
            {t('dataEntry.close')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  const ContentForDialogBox = (props) => {
    return (
      <>
        <RequestTemplateFormat
          tableRef={tableRef}
          getPageData={getRequestFields}
          title={getState().templateName}
          isEdit={false}
          getState={getState}
          selectedRecord={onCheckBoxSelection}
          onImageClick={handleImageClick}
        />
      </>
    )
  }

  const onCheckBoxSelection = async (requestId) => {
    if (requestId && requestId !== getState()?.newTemplateId) {
      setState({
        newTemplateId: requestId
      })
    }
  }
  const ButtonsForSaveAndAssignJob = props =>
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={onCancel}>buttons.cancel</BottomPaddedButton>
      <Button variant="contained" color="primary" onClick={props.update}>{t('buttons.select')}</Button>
    </>

  ButtonsForSaveAndAssignJob.propTypes = {
    update: PropTypes.func
  }

  const onCancel = () => {
    closeGeneralDialog()
    onClose()
  }

  const getRequest = async () => {
    const data = { accountLevel1: rowData.customer }
    const requests = await localGdeTransactions.getRequests(data)
    const requestList = []
    requests.forEach((doc) => {
      requestList.push(doc.data())
    })
    // REMOVED: Don't load images upfront - just store original references
    // const requestListWithNatsImg = await natsService.getNatsURL(requestList, constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG)
    setState({
      templateData: requestList, // Store original data without loading images
    })
  }

  const getRequestFields = async () => {
    await getRequest()
    const fields = getState().templateData

    fields.sort((a, b) => {
      return (new Date(b.createdTS)) - (new Date(a.createdTS))
    })

    const resultPromises = fields.map(doc => {
      const templateFields = Object.keys(doc.template).map((key) => {
        const data = `${key} (${doc.template[key].fieldId})`
        return data
      })

      return localGdeTransactions.getUserNameById(doc.workerId).then(createdBy => {
        return {
          requestId: doc.templateId,
          requestFields: templateFields,
          customTemplateName: doc.customTemplateName,
          createdBy: createdBy,
          createdOn: doc.createdTS,
          imgReference: doc.imgReference // Store original reference, don't load
        }
      })
    })
    const result = await Promise.all(resultPromises)
    return result
  }

  const onTemplateSelection = async () => {
    if (getState().newTemplateId !== '') {
      const requestData = await localGdeTransactionLite.getTemplateById(getState().newTemplateId)
      postService(requestData)
      successToast({ message: t('toast.templateUpdate'), title: t('toast.success') })
    } else {
      errorToast({ message: t('toast.selectTemplate'), isBlocking: false, closeIcon: true })
    }
  }

  const postService = async requestData => {
    const parentActivityId = rowData.activityId
    const activityDetails = await localGdeTransactions.getActivityByID(parentActivityId)
    const requestDetails = await localGdeTransactionLite.getRequestById(activityDetails.requestId)
    const initialStatus = activityDetails.status
    const activityData = {
      template: updateTemplateFields(requestData?.template, requestDetails?.confidence),
      status: 'In Progress',
      isPublished: false,
      isProcessed: false,
      updatedTS: (new Date()).toISOString(),
      templateLocked: {},
    }
    let newStat
    if (initialStatus === constants.activityStatus.pending || initialStatus === constants.activityStatus.inProgress) {
      newStat = initialStatus
    } else {
      newStat = false
    }
    await localGdeTransactions.updateActivityData(parentActivityId, activityData)
    onCancel()
    const imageData = {
      idp: {
        statusCode: '',
        status: '',
        exception: ''
      },
      idpResponse: {},
      isPublished: false,
      isProcessed: false,
      processedAt: '',
      publishedAt: '',
      messageId: '',
      idp_message_id: '',
      status: constants.activityStatus.submitted,
      updatedTS: (new Date()).toISOString(),
      template: updateTemplateFields(requestData?.template, requestDetails?.confidence),
      templateLocked: {},
    }
    // await localGdeTransactions.getImagesAndUpdate(parentActivityId, imageData, newStat)
    await localGdeTransactions.getImagesAndUpdate(parentActivityId, imageData, newStat, natsService.publishImgData.bind(natsService))
  }

  return (
    <>
      <ImageContainer />
    </>
  )
}

UpdateTemplate.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}

export const UpdateBox = (props) => {
  const { rowData, onClose } = props
  const { t } = useTranslation()
  const { natsService } = useNats()
  // const [state, setState, getState] = useMergeState(initialSate)
  // const tableRef = useRef()
  const [isDialogOpen, setDialogOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const isMountedRef = useRef(true)
  
  // Track component mount status
  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
    }
  }, [])
  
  const handleOpenDialog = () => {
    setDialogOpen(true)
  }

  const ContentForDialogBox = () => (
    <Box>
      <Typography variant="body2" color="textSecondary" style={{ marginTop: '10px', fontSize: '0.88rem' }}>
        <strong>{`${t('smartCatalog.plsNote')}`}</strong>{`${t('smartCatalog.plsNoteMsg1')}`}<strong>{rowData.boxId}</strong>{`${t('smartCatalog.plsNoteMsg2')}`}
      </Typography>
    </Box>
  )

  const ButtonsForSaveAndAssignJob = props => (
    <>
      <Button 
        color="primary" 
        variant="outlined" 
        onClick={onCancel}
        disabled={isLoading}
      >
        {t('buttons.cancel')}
      </Button>
      <Button 
        variant="contained" 
        color="primary" 
        onClick={postService}
        disabled={isLoading}
        startIcon={isLoading ? <CircularProgress size={16} /> : null}
      >
        {t('buttons.Continue')}
      </Button>
    </>
  )

  const onCancel = () => {
    if (isLoading) return // Prevent closing during operation
    if (!isMountedRef.current) return
    setDialogOpen(false)
    onClose()
  }

  const postService = async postObject => {
    if (isLoading) return // Prevent multiple clicks
    if (!isMountedRef.current) return
    
    setIsLoading(true)
    setBusy()
    
    try {
      const parentActivityId = rowData.activityId
      if (natsService) {
        try {
          await deleteNatsCapturedImagesForBox(natsService, rowData)
        } catch (err) {
          console.log('Error in image deletion on box reopen from nats :', err)
        }
      }
      const activityData = {
        status: 'pending',
        isPublished: false,
        isProcessed: false,
        updateTS: (new Date()).toISOString(),
        isReopen: true,
        isRetake: false,
        isException: false,
        wmsStatus: 'Pending',
        flatFileDetails: {},
        uploadTs: '',
        exceptionNote: '',
        isUploaded: false,
        ctFormatErr: 0,
        ctHITLReject: 0,
        ctIDPFail: 0
      }
      await localGdeTransactions.updateActivityData(parentActivityId, activityData)
      
      // Only update state if component is still mounted
      if (isMountedRef.current) {
        // Close dialog and show success message
        setDialogOpen(false)
        onClose()
        successToast({ message: t('toast.boxReopen'), title: t('toast.success') })
      }
    } catch (error) {
      console.error('Error in postService:', error)
      if (isMountedRef.current) {
        errorToast({ 
          message: t('toast.errorOccurred'), 
          title: t('toast.error'),
          isBlocking: false 
        })
      }
    } finally {
      if (isMountedRef.current) {
        setIsLoading(false)
      }
      clearBusy()
    }
  }

  useEffect(() => {
    handleOpenDialog()
  }, [])

  return (
    <>
      <Dialog
        open={isDialogOpen}
        onClose={isLoading ? undefined : onCancel}
        disableEscapeKeyDown={isLoading}
        sx={{
          '& .MuiDialog-paper': {
            maxHeight: '80vh',
            width: 'auto',
            maxWidth: '80%',
            overflow: 'visible',
          },
          '& .MuiDialogContent-root': {
            padding: '16px',
            overflow: 'visible',
          },
        }}
      >
        <DialogTitle>
          {t('templates.boxReopenTitle', { boxId: rowData.boxId })}
          <IconButton
            edge="end"
            color="inherit"
            onClick={onCancel}
            disabled={isLoading}
            aria-label="close"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: '#58595B',
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ overflow: 'visible', paddingBottom: '0px' }}>
          <ContentForDialogBox />
        </DialogContent>
        <DialogActions>
          <ButtonsForSaveAndAssignJob />
        </DialogActions>
      </Dialog>
    </>
  )
}

UpdateBox.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}

export const RetakeImageBox = (props) => {
  const { rowData, onClose } = props
  const { t } = useTranslation()
  const { natsService } = useNats()
  const [isDialogOpen, setDialogOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  
  const handleOpenDialog = () => {
    setDialogOpen(true)
  }

  const ContentForDialogBox = () => (
    <Box>
      <Typography variant="body2" color="textSecondary" style={{ marginTop: '10px', fontSize: '0.88rem' }}>
        <strong>{`${t('smartCatalog.plsNote')}`}</strong>{`${t('smartCatalog.plsNoteMsg1_retakeImage')}`}<strong>{rowData.boxId}</strong>{`${t('smartCatalog.plsNoteMsg2_retakeImage')}`}
      </Typography>
    </Box>
  )
  
  const ButtonsForSaveAndAssignJob = props => (
    <>
      <Button 
        color='primary' 
        variant='outlined' 
        onClick={onCancel}
        disabled={isLoading}
      >
        {t('buttons.cancel')}
      </Button>
      <Button 
        variant="contained" 
        color="primary" 
        onClick={postService}
        disabled={isLoading}
        startIcon={isLoading ? <CircularProgress size={16} /> : null}
      >
        {t('buttons.Continue')}
      </Button>
    </>
  )


  const onCancel = () => {
    if (isLoading) return // Prevent closing during operation
    setDialogOpen(false)
    onClose()
  }

  const postService = async postObject => {
    if (isLoading) return // Prevent multiple clicks
    
    setIsLoading(true)
    setBusy()
    
    try {
      const parentActivityId = rowData.activityId
      const activityData = {
        isRetake: true,
        status: 'In Progress',
        updatedTS: (new Date()).toISOString(),
      }
      await localGdeTransactions.updateActivityData(parentActivityId, activityData)
      
      const selectedImageId = rowData.imageId
      const imageData = {
        isPublished: false,
        status: 'Retake',
        updatedTS: (new Date()).toISOString(),
      }
      const updateAfterPublish = {
        isPublished: true,
        isProcessed: false,
        publishedAt: (new Date()).toISOString()
      }
      await localGdeTransactions.updateImage(selectedImageId, imageData)
      
      // fetch image data to publish to nats
      const imgData = await localGdeTransactions.getImageData(selectedImageId)
      const { publishedData, msgId } = await natsService.publishImgData(constants.LOCAL_NATS_SERVER, { ...imgData, ...updateAfterPublish })
      
      if (msgId) { 
        await localGdeTransactions.updateImage(selectedImageId, { ...updateAfterPublish, messageId: msgId }) 
      }
      
      // Close dialog and show success message
      setDialogOpen(false)
      onClose()
      successToast({ message: t('toast.imageRecapture'), title: t('toast.success') })
    } catch (error) {
      console.error('Error in postService:', error)
      errorToast({ 
        message: t('toast.errorOccurred'), 
        title: t('toast.error'),
        isBlocking: false 
      })
    } finally {
      setIsLoading(false)
      clearBusy()
    }
  }

  useEffect(() => {
    handleOpenDialog()
  }, [])

  return (
    <>
      <Dialog
        open={isDialogOpen}
        onClose={isLoading ? undefined : onCancel}
        disableEscapeKeyDown={isLoading}
        sx={{
          '& .MuiDialog-paper': {
            maxHeight: '80vh',
            width: 'auto',
            maxWidth: '80%',
            overflow: 'visible',
          },
          '& .MuiDialogContent-root': {
            padding: '16px',
            overflow: 'visible',
          },
        }}
      >
        <DialogTitle>
          {t('templates.retakeImageTitle', { boxId: rowData.boxId })}
          <IconButton
            edge="end"
            color="inherit"
            onClick={onCancel}
            disabled={isLoading}
            aria-label="close"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: '#58595B',
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ overflow: 'visible', paddingBottom: '0px' }}>
          <ContentForDialogBox />
        </DialogContent>
        <DialogActions>
          <ButtonsForSaveAndAssignJob />
        </DialogActions>
      </Dialog>
    </>
  )
}

RetakeImageBox.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}


export const ReprocessImage = (props) => {
  const { rowData, onClose } = props
  const { t } = useTranslation()
  const { natsService } = useNats()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    openGeneralDialog({
      title: t('templates.reprocessImageTitle', { boxId: rowData.boxId }),
      maxWidth: 'md',
      noTranslateTitle: true,
      message: '',
      buttons: <ButtonsForSaveAndAssignJob update={postService} isLoading={isLoading} />,
      closeX: !isLoading
    })
  }, [isLoading])

  const ButtonsForSaveAndAssignJob = props =>
    <>
      <BottomPaddedButton 
        color='primary' 
        variant='outlined' 
        onClick={onCancel}
        disabled={props.isLoading}
      >
        buttons.cancel
      </BottomPaddedButton>
      <Button 
        variant="contained" 
        color="primary" 
        onClick={props.update}
        disabled={props.isLoading}
        startIcon={props.isLoading ? <CircularProgress size={16} /> : null}
      >
        {t('buttons.Continue')}
      </Button>
    </>

  ButtonsForSaveAndAssignJob.propTypes = {
    update: PropTypes.func,
    isLoading: PropTypes.bool
  }

  const onCancel = () => {
    if (isLoading) return // Prevent closing during operation
    closeGeneralDialog()
    onClose()
  }

  const postService = async postObject => {
    if (isLoading) return // Prevent multiple clicks
    
    setIsLoading(true)
    setBusy()
    
    try {
      const selectedImageId = rowData.imageId
      const imageData = {
        isPublished: false,
        isReprocess: true,
        status: constants.activityStatus.submitted,
        updatedTS: (new Date()).toISOString(),
      }
      const updateAfterPublish = {
        isPublished: true,
        isProcessed: false,
        publishedAt: (new Date()).toISOString()
      }
      await localGdeTransactions.updateImage(selectedImageId, imageData)

      // fetch image data to publish to nats
      const imgData = await localGdeTransactions.getImageData(selectedImageId)
      const { publishedData, msgId } = await natsService.publishImgData(constants.LOCAL_NATS_SERVER, { ...imgData, ...updateAfterPublish })
      if (msgId) { 
        await localGdeTransactions.updateImage(selectedImageId, { ...updateAfterPublish, messageId: msgId }) 
      }
      await localGdeTransactions.updateFailedBoxStatusAfterImageRepublish(rowData.activityId, selectedImageId)
      
      // Close dialog and show success message
      closeGeneralDialog()
      onClose()
      successToast({ message: t('toast.imageReprocess'), title: t('toast.success') })
    } catch (error) {
      console.error('Error in postService:', error)
      errorToast({ 
        message: t('toast.errorOccurred'), 
        title: t('toast.error'),
        isBlocking: false 
      })
    } finally {
      setIsLoading(false)
      clearBusy()
    }
  }

  return null
}
ReprocessImage.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}

export const UpdateImageTemplate = (props) => {
  const { rowData, onClose } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const tableRef = useRef()
  const { natsService } = useNats()
  const { getImgFromNats } = useGetNatsImage()

  const [selectedImage, setSelectedImage] = useState(null)
  const [loadingImage, setLoadingImage] = useState(false)
  const [imageError, setImageError] = useState(false)
  const imageCache = useRef(new Map())
  const isDialogOpenRef = useRef(false)

  useEffect(() => {
    openGeneralDialog({
      title: t('smartCatalog.templates'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <div><ContentForDialogBox /></div>,
      buttons: <ButtonsForSaveAndAssignJob update={onTemplateSelection} />,
      closeX: false
    })
  }, [])

  const loadImageFromNats = async (imgReference) => {
    if (!imgReference) return null

    // Check cache first
    if (imageCache.current.has(imgReference)) {
      return imageCache.current.get(imgReference)
    }

    // Check if it's a NATS image
    if (imgReference.includes('nats')) {
      try {
        // const imageUrl = await natsService.getImgFromNats(
        //   constants.LOCAL_NATS_SERVER,
        //   constants.LOCAL_AI_REF_IMG,
        //   imgReference
        // )
        const imageUrl = await getImgFromNats(
          constants.LOCAL_NATS_SERVER,
          constants.LOCAL_AI_REF_IMG,
          imgReference
        )
        if (imageUrl) {
          imageCache.current.set(imgReference, imageUrl)
          return imageUrl
        }
      } catch (error) {
        console.error('Error loading image from NATS:', error)
        return null
      }
    }

    // For non-NATS images, return as-is
    return imgReference
  }

  const handleImageClick = async (imgReference) => {
    if (!imgReference) return

    isDialogOpenRef.current = true
    setLoadingImage(true)
    setSelectedImage(null)

    try {
      const imageUrl = await loadImageFromNats(imgReference)
      if (isDialogOpenRef.current) {
        if (imageUrl) {
          setSelectedImage(imageUrl)
        } else {
          setSelectedImage(null)
        }
      }
    } catch (error) {
      console.error('Error loading image:', error)
      if (isDialogOpenRef.current) {
        setSelectedImage(null)
      }
    } finally {
      if (isDialogOpenRef.current) {
        setLoadingImage(false)
      }
    }
  }

  const handleCloseImageDialog = () => {
    isDialogOpenRef.current = false
    setSelectedImage(null)
    setLoadingImage(false)
    setImageError(false)
  }

  const ImageDialog = () => {
    const isOpen = loadingImage || !!selectedImage || imageError

    if (!isOpen) return null

    return (
      <Dialog
        open={isOpen}
        onClose={handleCloseImageDialog}
        maxWidth="sm"
      >
        <DialogContent>
          {loadingImage && !selectedImage && !imageError
            ? <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '400px',
              minWidth: '400px',
              gap: 2
            }}>
              <CircularProgress size={40} />
              <Typography variant="body2" color="textSecondary">
                {t('Search.loading')}
              </Typography>
            </Box>
            : selectedImage && !imageError
              ? <img
                src={selectedImage}
                alt="Reference Image"
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  display: 'block',
                  margin: '0 auto'
                }}
                onError={() => {
                  // Image failed to load even though we got a URL
                  setSelectedImage(null)
                  setLoadingImage(false)
                  setImageError(true) // Show error message instead of closing
                }}
              />
              : <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px',
                minWidth: '400px',
                gap: 2
              }}>
                <Typography variant="body2" color="textSecondary">
                  {t('smartCatalog.imageNotAvailable')}
                </Typography>
              </Box>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImageDialog} color="primary">
            {t('dataEntry.close')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  const ContentForDialogBox = (props) => {
    return (
      <>
        <RequestTemplateFormat
          tableRef={tableRef}
          getPageData={getRequestFields}
          title={getState().templateName}
          isEdit={false}
          getState={getState}
          selectedRecord={onCheckBoxSelection}
          onImageClick={handleImageClick}
        />
      </>
    )
  }

  const onCheckBoxSelection = async (requestId) => {
    if (requestId && requestId !== getState()?.newTemplateId) {
      setState({
        newTemplateId: requestId
      })
    }
  }
  const ButtonsForSaveAndAssignJob = props =>
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={onCancel}>
        buttons.cancel
      </BottomPaddedButton>
      <Button variant="contained" color="primary" onClick={props.update}>
        {t('buttons.select')}
      </Button>
    </>

  ButtonsForSaveAndAssignJob.propTypes = {
    update: PropTypes.func
  }

  const onCancel = () => {
    closeGeneralDialog()
    onClose()
  }

  const getRequest = async () => {
    const data = { accountLevel1: rowData.customer }
    const requests = await localGdeTransactions.getRequests(data)
    const requestList = []
    requests.forEach((doc) => {
      requestList.push(doc.data())
    })
    // Don't load images here - just store original references
    // const requestListWithNatsImg = await natsService.getNatsURL(requestList, constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG)
    setState({
      templateData: requestList, // Use original data instead of loading images
    })
  }

  const getRequestFields = async () => {
    await getRequest()
    const fields = getState().templateData

    fields.sort((a, b) => {
      return (new Date(b.createdTS)) - (new Date(a.createdTS))
    })

    const resultPromises = fields.map(doc => {
      const templateFields = Object.keys(doc.template).map((key) => {
        const data = `${key} (${doc.template[key].fieldId})`
        return data
      })

      return localGdeTransactions.getUserNameById(doc.workerId).then(createdBy => {
        return {
          requestId: doc.templateId,
          requestFields: templateFields,
          customTemplateName: doc.customTemplateName,
          createdBy: createdBy,
          createdOn: doc.createdTS,
          imgReference: doc.imgReference
        }
      })
    })
    const result = await Promise.all(resultPromises)
    return result
  }

  const onTemplateSelection = async () => {
    if (getState().newTemplateId !== '') {
      // Close dialog immediately
      onCancel()
      // Show global loading indicator
      setBusy()
      try {
        const requestData = await localGdeTransactionLite.getTemplateById(getState().newTemplateId)
        await postService(requestData)
      } catch (error) {
        console.error('Error in template selection:', error)
        clearBusy()
      }
    } else {
      errorToast({ message: t('toast.selectTemplate'), isBlocking: false, closeIcon: true })
    }
  }

  const postService = async requestData => {
    try {
      console.log('GM: requestData, rowData', requestData, rowData)
      const requestDetails = await localGdeTransactionLite.getRequestById(rowData.requestId)
      const selectedImageId = rowData.imageId
      const imageData = {
        isPublished: false,
        isReprocess: true,
        status: constants.activityStatus.submitted,
        template: updateTemplateFields(requestData?.template, requestDetails?.confidence ?? 0),
        templateLocked: {},
        updatedTS: (new Date()).toISOString(),
      }
      const updateAfterPublish = {
        isPublished: true,
        isProcessed: false,
        publishedAt: (new Date()).toISOString()
      }
      await localGdeTransactions.updateImage(selectedImageId, imageData)

      // fetch image data to publish to nats
      const imgData = await localGdeTransactions.getImageData(selectedImageId)
      // const { publishedData, msgId } = await publishImgData(constants.LOCAL_NATS_SERVER, { ...imgData, ...updateAfterPublish })
      const { publishedData, msgId } = await natsService.publishImgData(constants.LOCAL_NATS_SERVER, { ...imgData, ...updateAfterPublish })
      if (msgId) { await localGdeTransactions.updateImage(selectedImageId, { ...updateAfterPublish, messageId: msgId }) }
      await localGdeTransactions.updateFailedBoxStatusAfterImageRepublish(rowData.activityId, selectedImageId)
      successToast({ message: t('toast.templateUpdate'), title: t('toast.success') })
    } catch (error) {
      console.error('Error updating template:', error)
      errorToast({ message: t('toast.errorOccurred') || 'An error occurred while updating the template', isBlocking: false, closeIcon: true })
      throw error // Re-throw to handle in onTemplateSelection
    } finally {
      clearBusy()
    }
  }

  return (
    <>
      <ImageDialog />
    </>
  )
}

UpdateImageTemplate.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}

export const UpdateImgRefImage = (props) => {
  const { rowData, onClose } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const { workerId } = getUser()
  const { natsService } = useNats()
  const { getImgFromNats } = useGetNatsImage()
  // const tableRef = useRef()
  const [newUpldImg, setNewUpldImg] = useState(null)
  const [isDialogOpen, setDialogOpen] = useState(false)
  const [currentRefImageUrl, setCurrentRefImageUrl] = useState(null)
  const [loadingCurrentImage, setLoadingCurrentImage] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)

  useEffect(() => {
    setDialogOpen(true) // Open dialog on component mount
  }, [])

  // Load current reference image when component mounts
  useEffect(() => {
    let isMounted = true

    const loadCurrentRefImage = async () => {
      // Check if rowData has imgReference or currentImageURL
      const imgRef = rowData.imgReference || rowData.currentImageURL || ''

      if (!imgRef) {
        if (isMounted) {
          setCurrentRefImageUrl('')
        }
        return
      }

      // If it's already a URL (not NATS), use it directly
      if (imgRef.startsWith('http://') || imgRef.startsWith('https://') || imgRef.startsWith('data:')) {
        if (isMounted) {
          setCurrentRefImageUrl(imgRef)
        }
        return
      }

      // If it's a NATS reference, load it
      if (imgRef.includes('nats')) {
        if (isMounted) {
          setLoadingCurrentImage(true)
        }
        try {
          // const imageUrl = await natsService.getImgFromNats(
          //   constants.LOCAL_NATS_SERVER,
          //   constants.LOCAL_AI_REF_IMG,
          //   imgRef
          // )
          const imageUrl = await getImgFromNats(
            constants.LOCAL_NATS_SERVER,
            constants.LOCAL_AI_REF_IMG,
            imgRef
          )
          if (isMounted) {
            if (imageUrl) {
              setCurrentRefImageUrl(imageUrl)
            } else {
              setCurrentRefImageUrl('')
            }
            setLoadingCurrentImage(false)
          }
        } catch (error) {
          if (isMounted) {
            console.error('Error loading current reference image:', error)
            setCurrentRefImageUrl('')
            setLoadingCurrentImage(false)
          }
        }
      } else {
        // For other cases, try to use as-is
        if (isMounted) {
          setCurrentRefImageUrl(imgRef)
        }
      }
    }

    loadCurrentRefImage()

    return () => {
      isMounted = false
    }
  }, [rowData, natsService])

  const setError = (value) => {
    setState({ error: value })
  }

  const ContentForDialogBox = () => {
    return (<>
      <Box sx={{ flexGrow: 1, minHeight: 300 }}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
              <TransformWrapper>
                {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                  <>
                    <Controls />
                    <TransformComponent>
                      <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                        {loadingCurrentImage
                          ? <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            width: '100%'
                          }}>
                            <CircularProgress size={40} />
                          </Box>
                          : currentRefImageUrl
                            ? <img
                              src={currentRefImageUrl}
                              style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }}
                              alt="Current Reference Image"
                              onError={() => {
                                // If image fails to load, clear it
                                setCurrentRefImageUrl('')
                              }}
                            />
                            : <Label style={{ width: '100%', height: 250 }}></Label>
                        }
                      </div>
                    </TransformComponent>
                  </>
                )}
              </TransformWrapper>
            </Box>
            <Typography variant="body1">{`${t('smartCatalog.currentRefImg')}`}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
              <TransformWrapper>
                {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                  <>
                    <Controls />
                    <TransformComponent>
                      <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                        {newUpldImg &&
                          <img src={newUpldImg} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />}
                      </div>
                    </TransformComponent>
                  </>
                )}
              </TransformWrapper>
            </Box>
            <Typography variant="body1" component="div">
              <InputFileUploadButton onImageCapture={handleImageUploadToNats} error={getState().error} setError={setError} maxSize={5} allowedFormats={['JPG', 'JPEG']} />
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>)
  }

  const ButtonsForSaveAndAssignJob = (props) => (
    <>
      <BottomPaddedButton
        color="primary"
        variant="outlined"
        onClick={onCancel}
        disabled={isUpdating} // Disable during update
      >
        {t('buttons.cancel')}
      </BottomPaddedButton>
      <Button
        variant="contained"
        color="primary"
        disabled={!newUpldImg?.length || isUpdating} // Disable during update
        onClick={handleUpdate}
      >
        {t('buttons.update')}
      </Button>
    </>
  )

  const onCancel = () => {
    if (!isUpdating) { // Prevent closing during update
      setDialogOpen(false)
      onClose()
    }
  }

  // Add wrapper function to handle update button click
  const handleUpdate = async () => {
    if (!getState().selectedImage) {
      setError('Please upload an image.')
      return
    }

    // Don't close dialog - keep it open to show loading
    setIsUpdating(true) // Show CircularProgress

    try {
      await postService()
      // Close dialog after successful update
      setDialogOpen(false)
      onClose()
    } catch (error) {
      console.error('Error updating reference image:', error)
      setIsUpdating(false) // Hide loading on error
    }
  }

  // const handleImageUpload = async (value) => {
  //   if (value) {
  //     setBusy()
  //     const imageRef = storageRef(storage, `smartCatalog/gde_refImg_${workerId}_${Date.now()}.jpg`)
  //     uploadBytes(imageRef, value)
  //       .then((snapshot) => {
  //         getDownloadURL(snapshot.ref)
  //           .then((url) => {
  //             const gspath = `gs://${snapshot.ref.bucket}/${snapshot.ref.fullPath}`
  //             setState({
  //               selectedImage: url,
  //               selectedImageGsPath: gspath,
  //             })
  //             setError('')
  //             clearBusy()
  //           })
  //           .catch((error) => {
  //             // eslint-disable-next-line
  //             console.log(error.message)
  //             setError(t('error.imageUploadFail'))
  //             clearBusy()
  //           })
  //       })
  //       .catch((error) => {
  //         // eslint-disable-next-line
  //         console.log(error.message)
  //         setError(t('error.imageUploadFail'))
  //         clearBusy()
  //       })
  //   }
  // }

  const handleImageUploadToNats = async (originalFile) => {
    if (originalFile) {
      const rename = `nats_refImg_${workerId}_${Date.now()}.jpg`
      const renamedFile = new File([originalFile], rename, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      })
      // const { nuid, name } = await uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, renamedFile)
      const { nuid, name } = await natsService.uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, renamedFile)
      setState({
        selectedImage: name,
        selectedImageGsPath: nuid,
      })
      // const tmpUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      // const tmpUrl = await natsService.getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      const tmpUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      setNewUpldImg(tmpUrl)
    } else {
      const error = getState().validationErrors
      setState({ validationErrors: { ...error, btnError: 'Incorrect format or size.' } })
    }
  }

  const postService = async postObject => {
    try {
      const selectedImageId = rowData.imageId
      if (getState().selectedImage) {
        const imageData = {
          isPublished: false,
          isReprocess: true,
          status: constants.activityStatus.submitted,
          updatedTS: (new Date()).toISOString(),
          imgReference: getState().selectedImage,
          imgReferenceURI: getState().selectedImageGsPath,
        }
        const updateAfterPublish = {
          isPublished: true,
          isProcessed: false,
          publishedAt: (new Date()).toISOString()
        }
        await localGdeTransactions.updateImage(selectedImageId, imageData)

        // fetch image data to publish to nats
        const imgData = await localGdeTransactions.getImageData(selectedImageId)
        const { publishedData, msgId } = await natsService.publishImgData(constants.LOCAL_NATS_SERVER, { ...imgData, ...updateAfterPublish })
        if (msgId) { await localGdeTransactions.updateImage(selectedImageId, { ...updateAfterPublish, messageId: msgId }) }
        await localGdeTransactions.updateFailedBoxStatusAfterImageRepublish(rowData.activityId, selectedImageId)
        successToast({ message: t('toast.refImageUpdate'), title: t('toast.success') })
      } else {
        setError('Please upload an image.')
        throw new Error('Please upload an image.')
      }
    } catch (error) {
      console.error('Error updating reference image:', error)
      errorToast({ message: t('toast.errorOccurred'), isBlocking: false, closeIcon: true })
      throw error // Re-throw to handle in handleUpdate
    } finally {
      setIsUpdating(false) // Hide loading indicator
    }
  }

  return (
    <Dialog
      open={isDialogOpen}
      onClose={onCancel}
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '80vh',
          width: 'auto',
          maxWidth: '80%',
          overflow: 'hidden',
          position: 'relative', // For overlay positioning
        },
        '& .MuiDialogContent-root': {
          padding: '16px',
          overflow: 'hidden',
        },
      }}
    >
      {isUpdating && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            gap: 2,
          }}
        >
          <CircularProgress size={40} />
          <Typography variant="body2" color="textSecondary">
            {t('Search.loading')}
          </Typography>
        </Box>
      )}

      <DialogTitle>
        {t('templates.refImageUpdate', { boxId: rowData.boxId })}
        <IconButton
          edge="end"
          color="inherit"
          onClick={onCancel}
          aria-label="close"
          disabled={isUpdating} // Disable close button during update
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#58595B',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: '0px' }}>
        <ContentForDialogBox />
      </DialogContent>
      <DialogActions>
        <ButtonsForSaveAndAssignJob />
      </DialogActions>
    </Dialog>
  )
}

UpdateImgRefImage.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}

export const UpdateImageTemplateAndRef = (props) => {
  const { rowData, onClose } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const tableRef = useRef()
  const { natsService } = useNats()
  const { getImgFromNats } = useGetNatsImage()

  const [selectedImage, setSelectedImage] = useState(null)
  const [loadingImage, setLoadingImage] = useState(false)
  const [imageError, setImageError] = useState(false)
  const imageCache = useRef(new Map())
  const isDialogOpenRef = useRef(false)

  useEffect(() => {
    const getRequestDetails = async () => {
      const requestDetails = await localGdeTransactionLite.getRequestById(rowData.requestId)
      rowData.confidence = requestDetails.confidence
    }
    getRequestDetails()

    openGeneralDialog({
      title: t('smartCatalog.templates'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <div><ContentForDialogBox /></div>,
      buttons: <ButtonsForSaveAndAssignJob update={onTemplateSelection} />,
      closeX: false
    })
  }, [])

  const loadImageFromNats = async (imgReference) => {
    if (!imgReference) return null

    return await getImgFromNats(
      constants.LOCAL_NATS_SERVER,
      constants.LOCAL_AI_REF_IMG,
      imgReference,
      true // Enable caching
    )

    // --- OLD CODE ---
    // // Check cache first
    // if (imageCache.current.has(imgReference)) {
    //   return imageCache.current.get(imgReference)
    // }
    // 
    // // For non-NATS images (URLs), return immediately and cache
    // if (!imgReference.includes('nats')) {
    //   if (imgReference.startsWith('http://') ||
    //     imgReference.startsWith('https://') ||
    //     imgReference.startsWith('data:')) {
    //     imageCache.current.set(imgReference, imgReference)
    //     return imgReference
    //   }
    //   return null
    // }
    // 
    //     // Check if it's a NATS image
    // if (imgReference.includes('nats')) {
    //   try {
    //     // const imageUrl = await natsService.getImgFromNats(
    //     //   constants.LOCAL_NATS_SERVER,
    //     //   constants.LOCAL_AI_REF_IMG,
    //     //   imgReference
    //     // )
    //     const imageUrl = await getImgFromNats(
    //       constants.LOCAL_NATS_SERVER,
    //       constants.LOCAL_AI_REF_IMG,
    //       imgReference
    //     )
    //     if (imageUrl) {
    //       imageCache.current.set(imgReference, imageUrl)
    //       return imageUrl
    //     }
    //   } catch (error) {
    //     console.error('Error loading image from NATS:', error)
    //     return null
    //   }
    // }
    // 
    // return null
  }

  const handleImageClick = async (imgReference) => {
    if (!imgReference) {
      // If no reference, show error immediately
      setImageError(true)
      setLoadingImage(false)
      setSelectedImage(null)
      return
    }

    // Reset error state
    setImageError(false)

    // --- OLD CODE ---
    // // Check cache first
    // if (imageCache.current.has(imgReference)) {
    //   const cachedImage = imageCache.current.get(imgReference)
    //   if (cachedImage) {
    //     isDialogOpenRef.current = true
    //     setSelectedImage(cachedImage)
    //     setLoadingImage(false)
    //     setImageError(false)
    //     return
    //   }
    // }
    
    isDialogOpenRef.current = true
    // Open dialog immediately with loading state
    setLoadingImage(true)
    setSelectedImage(null)
    setImageError(false)

    try {
      const imageUrl = await loadImageFromNats(imgReference)
      if (isDialogOpenRef.current) {
        if (imageUrl) {
          setSelectedImage(imageUrl)
          setImageError(false)
        } else {
          setSelectedImage(null)
          setImageError(true) // Set error if image couldn't be loaded
        }
      }
    } catch (error) {
      console.error('Error loading image:', error)
      if (isDialogOpenRef.current) {
        setSelectedImage(null)
        setImageError(true) // Set error on exception
      }
    } finally {
      if (isDialogOpenRef.current) {
        setLoadingImage(false)
      }
    }
  }

  const handleCloseImageDialog = () => {
    isDialogOpenRef.current = false
    setSelectedImage(null)
    setLoadingImage(false)
    setImageError(false) // Reset error state when closing
  }

  const ImageContainer = () => {
    // Keep dialog open if loading, has image, or has error
    const isOpen = loadingImage || !!selectedImage || imageError

    if (!isOpen) return null

    return (
      <Dialog
        open={isOpen}
        onClose={handleCloseImageDialog}
        maxWidth="sm"
      >
        <DialogContent>
          {loadingImage && !selectedImage && !imageError
            ? <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '400px',
              minWidth: '400px',
              gap: 2
            }}>
              <CircularProgress size={40} />
              <Typography variant="body2" color="textSecondary">
                {t('Search.loading')}
              </Typography>
            </Box>
            : selectedImage && !imageError
              ? <img
                src={selectedImage}
                alt="Reference Image"
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  display: 'block',
                  margin: '0 auto'
                }}
                onError={() => {
                  // Image failed to load even though we got a URL
                  setSelectedImage(null)
                  setLoadingImage(false)
                  setImageError(true) // Show error message instead of closing
                }}
              />
              : <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px',
                minWidth: '400px',
                gap: 2
              }}>
                <Typography variant="body2" color="textSecondary">
                  {t('smartCatalog.imageNotAvailable')}
                </Typography>
              </Box>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImageDialog} color="primary">
            {t('dataEntry.close')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  const ContentForDialogBox = (props) => {
    return (
      <>
        <RequestTemplateFormat
          tableRef={tableRef}
          getPageData={getRequestFields}
          title={getState().templateName}
          isEdit={false}
          getState={getState}
          selectedRecord={onCheckBoxSelection}
          onImageClick={handleImageClick} // Pass the image click handler
        />
      </>
    )
  }

  const onCheckBoxSelection = async (requestId) => {
    if (requestId && requestId !== getState()?.newTemplateId) {
      setState({
        newTemplateId: requestId
      })
    }
  }

  const ButtonsForSaveAndAssignJob = (props) =>
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={onCancel}>{t('buttons.cancel')}</BottomPaddedButton>
      <Button variant="contained" color="primary" onClick={props.update}>{t('buttons.select')}</Button>
    </>

  const getRequest = async () => {
    const data = { accountLevel1: rowData.customer }
    const requests = await localGdeTransactions.getRequests(data)
    const requestList = []
    requests.forEach((doc) => {
      requestList.push(doc.data())
    })
    // REMOVED: Don't load images upfront - just store original references
    // const requestListWithNatsImg = await natsService.getNatsURL(requestList, constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG)
    setState({
      templateData: requestList, // Store original data without loading images
    })
  }

  const getRequestFields = async () => {
    await getRequest()
    const fields = getState().templateData

    fields.sort((a, b) => {
      return (new Date(b.createdTS)) - (new Date(a.createdTS))
    })

    const resultPromises = fields.map(doc => {
      const templateFields = Object.keys(doc.template).map((key) => {
        const data = `${key} (${doc.template[key].fieldId})`
        return data
      })

      return localGdeTransactions.getUserNameById(doc.workerId).then(createdBy => {
        return {
          requestId: doc.templateId,
          requestFields: templateFields,
          customTemplateName: doc.customTemplateName,
          createdBy: createdBy,
          createdOn: doc.createdTS,
          imgReference: doc.imgReference // Store original reference, don't load
        }
      })
    })
    const result = await Promise.all(resultPromises)
    return result
  }

  const onTemplateSelection = async () => {
    if (getState().newTemplateId !== '') {
      const requestData = await localGdeTransactionLite.getTemplateById(getState().newTemplateId)
      setState({ selectedTemplateData: requestData.template })
      openUpdateRefImageDialog()
    } else {
      errorToast({ message: t('toast.selectTemplate'), isBlocking: false, closeIcon: true })
    }
  }


  const onCancel = () => {
    closeGeneralDialog()
    onClose()
  }

  const openUpdateRefImageDialog = () => {
    openGeneralDialog({
      title: t('templates.refImageUpdate', { boxId: rowData.boxId }),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <UpdateTemplateRefImage
        rowData={rowData}
        selectedTemplateData={getState().selectedTemplateData}
        onClose={onCancel}
        natsService={natsService} // Pass natsService as prop
      />,
      closeX: false
    })
  }

  return (
    <>
      <ImageContainer />
    </>
  )
}

UpdateImageTemplateAndRef.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}

export const UpdateTemplateRefImage = (props) => {
  const { rowData, onClose, selectedTemplateData, natsService } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const { workerId } = getUser()
  const [isDialogOpen, setDialogOpen] = useState(true)
  const [newUpldImg, setNewUpldImg] = useState(null)
  const [currentRefImageUrl, setCurrentRefImageUrl] = useState(null)
  const [loadingCurrentImage, setLoadingCurrentImage] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false) // Add loading state for update
  const { getImgFromNats } = useGetNatsImage()
  // Load current reference image when component mounts
  useEffect(() => {
    const loadCurrentRefImage = async () => {
      // Check if rowData has imgReference or currentImageURL
      const imgRef = rowData.imgReference || rowData.currentImageURL || ''

      if (!imgRef) {
        setCurrentRefImageUrl('')
        return
      }

      // If it's already a URL (not NATS), use it directly
      if (imgRef.startsWith('http://') || imgRef.startsWith('https://') || imgRef.startsWith('data:')) {
        setCurrentRefImageUrl(imgRef)
        return
      }

      // If it's a NATS reference, load it
      if (imgRef.includes('nats')) {
        setLoadingCurrentImage(true)
        try {
          // const imageUrl = await natsService.getImgFromNats(
          //   constants.LOCAL_NATS_SERVER,
          //   constants.LOCAL_AI_REF_IMG,
          //   imgRef
          // )
          const imageUrl = await getImgFromNats(
            constants.LOCAL_NATS_SERVER,
            constants.LOCAL_AI_REF_IMG,
            imgRef
          )
          if (imageUrl) {
            setCurrentRefImageUrl(imageUrl)
          } else {
            setCurrentRefImageUrl('')
          }
        } catch (error) {
          console.error('Error loading current reference image:', error)
          setCurrentRefImageUrl('')
        } finally {
          setLoadingCurrentImage(false)
        }
      } else {
        // For other cases, try to use as-is
        setCurrentRefImageUrl(imgRef)
      }
    }

    loadCurrentRefImage()
  }, [rowData, natsService])

  const setError = (value) => {
    setState({ error: value })
  }

  const ContentForDialogBox = () => {
    return (
      <>
        <Box sx={{ flexGrow: 1, minHeight: 300 }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
                <TransformWrapper>
                  {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <>
                      <Controls />
                      <TransformComponent>
                        <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                          {loadingCurrentImage
                            ? <Box sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '100%',
                              width: '100%'
                            }}>
                              <CircularProgress size={40} />
                            </Box>
                            : currentRefImageUrl
                              ? <img
                                src={currentRefImageUrl}
                                style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }}
                                alt="Current Reference Image"
                                onError={() => {
                                  // If image fails to load, clear it
                                  setCurrentRefImageUrl('')
                                }}
                              />
                              : <Label style={{ width: '100%', height: 250 }}></Label>
                          }
                        </div>
                      </TransformComponent>
                    </>
                  )}
                </TransformWrapper>
              </Box>
              <Typography variant="body1">{`${t('smartCatalog.currentRefImg')}`}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
                <TransformWrapper>
                  {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <>
                      <Controls />
                      <TransformComponent>
                        <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                          {newUpldImg &&
                            <img src={newUpldImg} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />}
                        </div>
                      </TransformComponent>
                    </>
                  )}
                </TransformWrapper>
              </Box>
              <Typography variant="body1" component="div">
                {/* <InputFileUploadButton onImageCapture={handleImageUpload} error={getState().error} setError={setError} maxSize={5} allowedFormats = {['JPG', 'JPEG']} /> */}
                <InputFileUploadButton onImageCapture={handleImageUploadToNats} error={getState().error} setError={setError} maxSize={5} allowedFormats={['JPG', 'JPEG']} />
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </>
    )
  }

  const ButtonsForSaveAndAssignJob = (props) => (
    <>
      <BottomPaddedButton
        color='primary'
        variant='outlined'
        onClick={onCancel}
        disabled={isUpdating} // Disable during update
      >
        {t('buttons.cancel')}
      </BottomPaddedButton>
      <Button
        variant="contained"
        color="primary"
        disabled={!newUpldImg?.length || isUpdating} // Disable during update
        onClick={handleUpdate}
      >
        {t('buttons.update')}
      </Button>
    </>
  )

  const onCancel = () => {
    if (!isUpdating) { // Prevent closing during update
      setDialogOpen(false)
      onClose()
    }
  }

  const handleUpdate = async () => {
    if (!getState().selectedImage) {
      setError('Please upload an image.')
      return
    }
    setIsUpdating(true) // Show CircularProgress

    try {
      await postService()
      // Close dialog after successful update
      setDialogOpen(false)
      onClose()
    } catch (error) {
      console.error('Error updating reference image:', error)
      setIsUpdating(false) // Hide loading on error
    }
  }

  // const handleImageUpload = async (value) => {
  //   if (value) {
  //     setBusy()
  //     const imageRef = storageRef(storage, `smartCatalog/gde_refImg_${workerId}_${Date.now()}.jpg`)
  //     uploadBytes(imageRef, value)
  //       .then((snapshot) => {
  //         getDownloadURL(snapshot.ref)
  //           .then((url) => {
  //             const gspath = `gs://${snapshot.ref.bucket}/${snapshot.ref.fullPath}`
  //             setState({
  //               selectedImage: url,
  //               selectedImageGsPath: gspath,
  //             })
  //             setError('')
  //             clearBusy()
  //           })
  //           .catch((error) => {
  //             // eslint-disable-next-line
  //             console.error(error.message)
  //             setError(t('error.imageUploadFail'))
  //             clearBusy()
  //           })
  //       })
  //       .catch((error) => {
  //         // eslint-disable-next-line
  //         console.error(error.message)
  //         setError(t('error.imageUploadFail'))
  //         clearBusy()
  //       })
  //   }
  // }

  const handleImageUploadToNats = async (originalFile) => {
    if (originalFile) {
      const rename = `nats_refImg_${workerId}_${Date.now()}.jpg`
      const renamedFile = new File([originalFile], rename, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      })
      // const { nuid, name } = await uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, renamedFile)
      const { nuid, name } = await natsService.uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, renamedFile)
      setState({
        selectedImage: name,
        selectedImageGsPath: nuid,
      })
      // const tmpUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      // const tmpUrl = await natsService.getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      const tmpUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      setNewUpldImg(tmpUrl)
    } else {
      const error = getState().validationErrors
      setState({ validationErrors: { ...error, btnError: 'Incorrect format or size.' } })
    }
  }

  const postService = async (postObject) => {
    try {
      const selectedImageId = rowData.imageId
      if (getState().selectedImage) {
        const imageData = {
          isPublished: false,
          isReprocess: true,
          status: constants.activityStatus.submitted,
          template: updateTemplateFields(selectedTemplateData, rowData.confidence),
          templateLocked: {},
          updatedTS: (new Date()).toISOString(),
          imgReference: getState().selectedImage,
          imgReferenceURI: getState().selectedImageGsPath,
        }
        const updateAfterPublish = {
          isPublished: true,
          isProcessed: false,
          publishedAt: (new Date()).toISOString()
        }
        await localGdeTransactions.updateImage(selectedImageId, imageData)

        // fetch image data to publish to nats
        const imgData = await localGdeTransactions.getImageData(selectedImageId)
        const { publishedData, msgId } = await natsService.publishImgData(constants.LOCAL_NATS_SERVER, { ...imgData, ...updateAfterPublish })
        if (msgId) { await localGdeTransactions.updateImage(selectedImageId, { ...updateAfterPublish, messageId: msgId }) }
        await localGdeTransactions.updateFailedBoxStatusAfterImageRepublish(rowData.activityId, selectedImageId)
        successToast({ message: t('toast.templateAndRefImageUpdate'), title: t('toast.success') })
      } else {
        setError('Please upload an image.')
        throw new Error('Please upload an image.')
      }
    } catch (error) {
      console.error('Error updating reference image:', error)
      errorToast({ message: t('toast.errorOccurred'), isBlocking: false, closeIcon: true })
      throw error // Re-throw to handle in handleUpdate
    } finally {
      setIsUpdating(false) // Hide loading indicator
    }
  }

  return (
    <Dialog
      open={isDialogOpen}
      onClose={onCancel}
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '80vh',
          width: 'auto',
          maxWidth: '80%',
          overflow: 'hidden',
          position: 'relative', // For overlay positioning
        },
        '& .MuiDialogContent-root': {
          padding: '16px',
          overflow: 'hidden',
        },
      }}
    >
      {isUpdating && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            gap: 2,
          }}
        >
          <CircularProgress size={40} />
          <Typography variant="body2" color="textSecondary">
            {t('Search.loading') || 'Updating...'}
          </Typography>
        </Box>
      )}

      <DialogTitle>
        {t('templates.refImageUpdate', { boxId: rowData.boxId })}
        <IconButton
          edge="end"
          color="inherit"
          onClick={onCancel}
          aria-label="close"
          disabled={isUpdating} // Disable close button during update
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#58595B',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: '0px' }}>
        <ContentForDialogBox />
      </DialogContent>
      <DialogActions>
        <ButtonsForSaveAndAssignJob />
      </DialogActions>
    </Dialog>
  )
}

export const TemplateAndRefOnImgCature = (props) => {
  const { rowData, onClose, selectedTemplateData, setCameraRef, natsService: natsServiceProp, getImgFromNats } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const [isDialogOpen, setDialogOpen] = useState(true)
  const { workerId } = getUser()
  const natsContext = useNats()
  // const { getImgFromNats } = useGetNatsImage()
  // eslint-disable-next-line
  // const [refImage, setRefImage] = useState(false)
  const [newUpldImg, setNewUpldImg] = useState(null)
  const [loadedRefImage, setLoadedRefImage] = useState(null)
  const [loadingRefImage, setLoadingRefImage] = useState(false)
  const [saving, setSaving] = useState(false)
  const natsService = natsServiceProp || (natsContext?.natsService)

  useEffect(() => {
    if (!natsService || !rowData?.imgReference) {
      setLoadedRefImage(null)
      return
    }

    if (rowData.imgReference.startsWith('http://') ||
      rowData.imgReference.startsWith('https://') ||
      rowData.imgReference.startsWith('data:')) {
      setLoadedRefImage(rowData.imgReference)
      return
    }

    if (rowData.imgReference.includes('nats')) {
      setLoadingRefImage(true)
      // natsService.getImgFromNats(
      getImgFromNats(
        constants.LOCAL_NATS_SERVER,
        constants.LOCAL_AI_REF_IMG,
        rowData.imgReference
      )
        .then(imageUrl => {
          setLoadedRefImage(imageUrl)
        })
        .catch(error => {
          console.error('Error loading reference image:', error)
          setLoadedRefImage(null)
        })
        .finally(() => {
          setLoadingRefImage(false)
        })
    } else {
      setLoadedRefImage(rowData.imgReference)
    }
  }, [rowData?.imgReference, natsService, getImgFromNats])

  if (!natsService) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="error">
          {t('smartCatalogLocal.natsServiceNotAvailable')}
        </Typography>
      </Box>
    )
  }

  const setError = (value) => {
    setState({ error: value })
  }

  const handleImageUploadToNats = async (originalFile) => {
    setBusy()
    if (originalFile) {
      const rename = `nats_refImg_${workerId}_${Date.now()}.jpg`
      const renamedFile = new File([originalFile], rename, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      })
      // const { nuid, name } = await uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, renamedFile)
      const { nuid, name } = await natsService.uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, renamedFile)
      setState({
        selectedImage: name,
        selectedImageGsPath: nuid,
      })
      // const tmpUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      // const tmpUrl = await natsService.getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      const tmpUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      setNewUpldImg(tmpUrl)
      postService(name, nuid, rowData?.id)
    } else {
      const error = getState().validationErrors
      setState({ validationErrors: { ...error, btnError: 'Incorrect format or size.' } })
    }
    clearBusy()
  }

  const ContentForDialogBox = () => {
    return (
      <>
        <Box sx={{ flexGrow: 1, minHeight: 300 }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
                <TransformWrapper>
                  {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <>
                      <Controls />
                      <TransformComponent>
                        <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                          {loadingRefImage
                            ? <Box sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '100%',
                              minHeight: '50%',
                              minWidth: '300px'
                            }}>
                              <CircularProgress size={30} />
                            </Box>
                            : loadedRefImage
                              ? <img
                                src={loadedRefImage}
                                style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }}
                                alt="BoxImage"
                                onError={() => {
                                  setLoadedRefImage(null)
                                }}
                              />
                              : <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100%',
                                minHeight: '50%',
                                minWidth: '300px',
                                color: '#999'
                              }}>
                                <Typography variant="body2">
                                  {t('smartCatalog.imageNotAvailable')}
                                </Typography>
                              </Box>
                          }
                        </div>
                      </TransformComponent>
                    </>
                  )}
                </TransformWrapper>
              </Box>
              <Typography variant="body1">{`${t('smartCatalog.currentRefImg')}`}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
                <TransformWrapper>
                  {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <>
                      <Controls />
                      <TransformComponent>
                        <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                          {newUpldImg &&
                            <img src={newUpldImg} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />}
                        </div>
                      </TransformComponent>
                    </>
                  )}
                </TransformWrapper>
              </Box>
              <Typography variant="body1" component="div">
                {/* <InputFileUploadButton onImageCapture={handleImageUpload} error={getState().error} setError={setError} maxSize={5} allowedFormats = {['JPG', 'JPEG']} /> */}
                <InputFileUploadButton onImageCapture={handleImageUpload} setCameraRef={setCameraRef} error={getState().error} setError={setError} maxSize={5} allowedFormats={['JPG', 'JPEG']} />
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </>
    )
  }

  // const ButtonsForSaveAndAssignJob = (props) => (
  //   <>
  //     <BottomPaddedButton color='primary' variant='outlined' onClick={onCancel}>{t('buttons.cancel')}</BottomPaddedButton>
  //     {/* <Button variant="contained" color="primary" disabled={!newUpldImg?.length} onClick={postService}>{t('buttons.update')}</Button> */}
  //   </>
  // )

  const ButtonsForRefImgUpdate = (props) => (
    <>
      <BottomPaddedButton
        color='primary'
        variant='outlined'
        onClick={onCancel}
        disabled={saving}
      >
        {t('buttons.cancel')}
      </BottomPaddedButton>
      <Button
        variant="contained"
        color="primary"
        disabled={!newUpldImg?.length || saving}
        onClick={postService}
      >
        {saving
          ? <>
            <CircularProgress size={16} style={{ marginRight: 8 }} />
            {t('buttons.updating')}
          </>
          : t('buttons.update')
        }
      </Button>
    </>
  )

  const onCancel = () => {
    setDialogOpen(false)
    onClose()
  }

  const handleImageUpload = async (value) => {
    handleImageUploadToNats(value)
  }

  // const handleImageUpload = async (value) => {
  //   if (value) {
  //     setBusy()
  //     const imageRef = storageRef(storage, `smartCatalog/gde_refImg_${workerId}_${Date.now()}.jpg`)
  //     uploadBytes(imageRef, value)
  //       .then((snapshot) => {
  //         getDownloadURL(snapshot.ref)
  //           .then((url) => {
  //             const gspath = `gs://${snapshot.ref.bucket}/${snapshot.ref.fullPath}`
  //             setState({
  //               selectedImage: url,
  //               selectedImageGsPath: gspath,
  //             })
  //             setError('')
  //             clearBusy()
  //           })
  //           .catch((error) => {
  //             // eslint-disable-next-line
  //             console.error(error.message)
  //             setError(t('error.imageUploadFail'))
  //             clearBusy()
  //           })
  //       })
  //       .catch((error) => {
  //         // eslint-disable-next-line
  //         console.error(error.message)
  //         setError(t('error.imageUploadFail'))
  //         clearBusy()
  //       })
  //   }
  // }

  const postService = async (postObject) => {
    if (!getState().selectedImage) {
      onCancel()
      return
    }

    setSaving(true)

    try {
      const selectedImg = getState().selectedImage
      const selectedImgGsPath = getState().selectedImageGsPath

      // This way the image is ready when we update the UI
      let imageUrl = null
      if (selectedImg && selectedImg.includes('nats')) {
        try {
          // imageUrl = await natsService.getImgFromNats(
          //   constants.LOCAL_NATS_SERVER,
          //   constants.LOCAL_AI_REF_IMG,
          //   selectedImg
          // )
          imageUrl = await getImgFromNats(
            constants.LOCAL_NATS_SERVER,
            constants.LOCAL_AI_REF_IMG,
            selectedImg
          )
        } catch (error) {
          console.error('Error pre-loading image:', error)
        }
      }

      // Pass the pre-loaded URL if available to speed up display
      if (selectedTemplateData) {
        await selectedTemplateData(selectedImg, selectedImgGsPath, rowData?.id, imageUrl)
      }
      await new Promise(resolve => setTimeout(resolve, 300))

      onCancel()
    } catch (error) {
      console.error('Error updating reference image:', error)
      errorToast({ message: t('toast.failedToUpdate'), isBlocking: false })
      setSaving(false)
    }
  }

  return (
    <Dialog
      open={isDialogOpen}
      onClose={onCancel}
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '80vh',
          width: 'auto',
          maxWidth: '80%',
          overflow: 'hidden',
        },
        '& .MuiDialogContent-root': {
          padding: '16px',
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle>
        {t('templates.refImageUpdate', { boxId: rowData.boxId || rowData.id })}
        {!saving && (
          <IconButton
            edge="end"
            color="inherit"
            onClick={onCancel}
            aria-label="close"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: '#58595B',
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: '0px', position: 'relative' }}>
        {saving && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
              gap: 2,
            }}
          >
            <CircularProgress size={40} />
            <Typography variant="body2" color="textSecondary">
              {t('Search.loading')}
            </Typography>
          </Box>
        )}
        <ContentForDialogBox />
      </DialogContent>
      <DialogActions>
        <ButtonsForRefImgUpdate />
      </DialogActions>
    </Dialog>
  )
}

export const QCReferenceImageChange = (props) => {
  const { rowData, onClose, selectedReferenceData, setRefImage } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const [isDialogOpen, setDialogOpen] = useState(true)
  const [newUpldImg, setNewUpldImg] = useState(null)
  const { workerId } = getUser()
  const { natsService } = useNats()
  const { getImgFromNats } = useGetNatsImage()

  const setError = (value) => {
    setState({ error: value })
  }

  const ContentForDialogBox = () => {
    return (
      <>
        <Box sx={{ flexGrow: 1, minHeight: 300 }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
                <TransformWrapper>
                  {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <>
                      <Controls />
                      <TransformComponent>
                        <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                          {rowData.imgReference !== ''
                            ? <img src={rowData.imgReference} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />
                            : <Label style={{ width: '100%', height: 250 }}></Label>
                          }
                        </div>
                      </TransformComponent>
                    </>
                  )}
                </TransformWrapper>
              </Box>
              <Typography variant="body1">{`${t('smartCatalog.currentRefImg')}`}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
                <TransformWrapper>
                  {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <>
                      <Controls />
                      <TransformComponent>
                        <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                          {newUpldImg &&
                            <img src={newUpldImg} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />}
                        </div>
                      </TransformComponent>
                    </>
                  )}
                </TransformWrapper>
              </Box>
              <Typography variant="body1" component="div">
                {/* <InputFileUploadButton onImageCapture={handleImageUpload} error={getState().error} setError={setError} maxSize={5} allowedFormats = {['JPG', 'JPEG']} /> */}
                <InputFileUploadButton onImageCapture={handleImageUploadToNats} error={getState().error} setError={setError} maxSize={5} allowedFormats={['JPG', 'JPEG']} />
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </>
    )
  }

  const ButtonsForQCUpdate = (props) => (
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={onCancel}>{t('buttons.cancel')}</BottomPaddedButton>
      <Button variant="contained" color="primary" disabled={!newUpldImg?.length} onClick={postService}>{t('buttons.update')}</Button>
    </>
  )

  const onCancel = () => {
    setDialogOpen(false)
    onClose()
  }

  // const handleImageUpload = async (value) => {
  //   if (value) {
  //     setBusy()
  //     const imageRef = storageRef(storage, `smartCatalog/gde_refImg_${workerId}_${Date.now()}.jpg`)
  //     uploadBytes(imageRef, value)
  //       .then((snapshot) => {
  //         getDownloadURL(snapshot.ref)
  //           .then((url) => {
  //             const gspath = `gs://${snapshot.ref.bucket}/${snapshot.ref.fullPath}`
  //             setState({
  //               selectedImage: url,
  //               selectedImageGsPath: gspath,
  //             })
  //             setError('')
  //             clearBusy()
  //           })
  //           .catch((error) => {
  //             // eslint-disable-next-line
  //             console.error(error.message)
  //             setError(t('error.imageUploadFail'))
  //             clearBusy()
  //           })
  //       })
  //       .catch((error) => {
  //         // eslint-disable-next-line
  //         console.error(error.message)
  //         setError(t('error.imageUploadFail'))
  //         clearBusy()
  //       })
  //   }
  // }

  const handleImageUploadToNats = async (originalFile) => {
    if (originalFile) {
      const rename = `nats_refImg_${workerId}_${Date.now()}.jpg`
      const renamedFile = new File([originalFile], rename, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      })
      // const { nuid, name } = await uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, renamedFile)
      const { nuid, name } = await natsService.uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, renamedFile)
      setState({
        selectedImage: name,
        selectedImageGsPath: nuid,
      })
      // const tmpUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      // const tmpUrl = await natsService.getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      const tmpUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
      setNewUpldImg(tmpUrl)
    } else {
      const error = getState().validationErrors
      setState({ validationErrors: { ...error, btnError: 'Incorrect format or size.' } })
    }
  }

  const postService = async (postObject) => {
    if (getState().selectedImage) {
      selectedReferenceData(getState().selectedImage, getState().selectedImageGsPath, rowData?.id)
      setRefImage(getState().selectedImage)
      onCancel()
    } else {
      selectedReferenceData(rowData.imgReference, rowData.imgReferenceURI)
      setRefImage(rowData.imgReference)
      onCancel()
    }
  }

  return (
    <Dialog
      open={isDialogOpen}
      onClose={onCancel}
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '80vh',
          width: 'auto',
          maxWidth: '80%',
          overflow: 'hidden',
        },
        '& .MuiDialogContent-root': {
          padding: '16px',
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle>
        {t('templates.refImageUpdate', { boxId: rowData.skpBoxNbr || rowData.id })}
        <IconButton
          edge="end"
          color="inherit"
          onClick={onCancel}
          aria-label="close"
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#58595B',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: '0px' }}>
        <ContentForDialogBox />
      </DialogContent>
      <DialogActions>
        <ButtonsForQCUpdate />
      </DialogActions>
    </Dialog>
  )
}

export const Controls = () => {
  const { zoomIn, zoomOut, resetTransform } = useControls()

  return (
    <ZoomTool>
      <IconButton aria-label="zoom in" onClick={() => zoomIn()}>
        <ZoomInIcon />
      </IconButton>
      <IconButton aria-label="zoom out" onClick={() => zoomOut()}>
        <ZoomOutIcon />
      </IconButton>
      <IconButton aria-label="zoom out" onClick={() => resetTransform()}>
        <RestartAltIcon />
      </IconButton>
    </ZoomTool>
  )
}